export default "__VITE_ASSET__BOkM0074__"